import "./App.css"
import { Homepage } from "./components/homepage/homepage"

function App() {
  return <Homepage />
}

export default App
